/** Thai strings for this area (English source text -> Thai). */
export const BATTLE: Record<string, string> = {
  /* ---- Ink Strike trace mini-game (ui/traceGame.ts) ---- */
  'Ink Strike': 'ลากหมึกโจมตี',
  'Ink Strike!': 'ลากหมึกโจมตี!',
  'Trace the dotted shape': 'ลากเส้นตามรอยประ',
  'Trace the dotted shape in one go: the neater, the harder you hit!': 'ลากตามรอยประให้จบในเส้นเดียว ยิ่งเป๊ะยิ่งตีแรง! (เริ่มที่จุดเขียว)',
  'Perfect line! {n}%': 'เป๊ะมาก! {n}%',
  'Nice! {n}%': 'ดีเลย! {n}%',
  'Missed… {n}%': 'พลาด… {n}%',
  '✏️ Ink Strike! Trace the shape for an extra hit.': '✏️ ลากหมึกโจมตี! ลากตามรูปเพื่อตีเพิ่ม',
  '✏️ Ink Strike missed ({n}%).': '✏️ ลากหมึกพลาด ({n}%)',
  '✏️ Ink Strike {n}%: {damage} extra damage!': '✏️ ลากหมึก {n}%: ตีเพิ่ม {damage}!',
  'Ink Strike: trace a shape after some won rounds for an extra hit': 'มินิเกมลากหมึก: บางรอบที่ชนะ ให้ลากเส้นตามรูปเพื่อตีเพิ่ม',
  /* ---- Battle twists: tells, boss rage, page events (combat/twists.ts) ---- */
  '{name} looks like it is winding up {move}…': '{name} ทำท่าเหมือนจะออก{move}…',
  'Clever monsters sometimes bluff!': 'มอนสเตอร์เก่งๆ ชอบหลอกนะ!',
  '{name} is charging a big hit! It wins: it hits hard. You win: it takes extra damage.': '{name} กำลังชาร์จท่าใหญ่! มันชนะ = ตีแรงมาก · เธอชนะ = มันโดนหนักขึ้น',
  "{name}'s ink is full: its ultimate is coming this round!": 'หมึกของ {name} เต็มแล้ว รอบนี้มันจะใช้ท่าไม้ตาย!',
  'ANGRY!': 'โกรธแล้ว!',
  '😡 {name} is angry! It hits harder, bluffs more and charges more often.': '😡 {name} โกรธแล้ว! ตีแรงขึ้น หลอกบ่อยขึ้น และชาร์จท่าใหญ่ถี่ขึ้น',
  'Page event': 'เหตุการณ์หน้ากระดาษ',
  'Ink Rain': 'ฝนหมึก',
  'Double Page': 'หน้าคู่',
  'Paper Cut': 'กระดาษบาด',
  'Mixed-up Hands': 'ปุ่มสลับที่',
  'The winner of this round heals {n}% HP.': 'คนชนะรอบนี้ฟื้น HP {n}%',
  'Both sides get +{n} ink after this round.': 'จบรอบนี้ทั้งสองฝั่งได้หมึก +{n}',
  "This round's hit lands twice!": 'รอบนี้ใครชนะ ตีโดนสองครั้ง!',
  'A tie this round stings both sides.': 'ถ้ารอบนี้เสมอ ทั้งสองฝั่งโดนกระดาษบาด',
  'The hand buttons got shuffled. Look before you tap!': 'ปุ่มค้อน กระดาษ กรรไกรสลับที่กัน ดูดีๆ ก่อนกดนะ!',
  '{event}: {name} heals {hp} HP.': '{event}: {name} ฟื้น {hp} HP',
  '{event}: {name} takes {n} more damage.': '{event}: {name} โดนเพิ่มอีก {n}',
  '{event}: both sides soak up more ink.': '{event}: ทั้งสองฝั่งได้หมึกเพิ่ม',
  /* ---- Losing streaks and leaving battles (systems/injury.ts) ---- */
  '{name} is hurt and resting for {n} more min. Play another hero meanwhile!': '{name} บาดเจ็บอยู่ ต้องพักอีก {n} นาที ระหว่างนี้ไปเล่นกับฮีโร่ตัวอื่นก่อนนะ!',
  '{name} is hurt and must rest for {n} min.': '{name} บาดเจ็บ ต้องพัก {n} นาที',
  'You left the battle against {monster} half-way: it counts as a loss.': 'ออกจากการต่อสู้กับ {monster} กลางคัน นับว่าแพ้',
  '{hero} ran from {monster}': '{hero} หนีจาก {monster}',
  'Leaving a battle half-way counts as a loss.': 'ออกจากการต่อสู้กลางคัน (รีเฟรช/ปิดหน้า) นับว่าแพ้',
  '{name} lost {n} times in a row and is hurt: resting for {m} min. Play another hero meanwhile!': '{name} แพ้ติดกัน {n} ครั้งจนบาดเจ็บ ต้องพัก {m} นาที ระหว่างนี้ไปเล่นกับฮีโร่ตัวอื่นก่อนนะ!',
  'Losses in a row: {n}/{max}. At {max} the hero gets hurt and must rest.': 'แพ้ติดกัน {n}/{max} ครั้ง ถ้าครบ {max} ฮีโร่จะบาดเจ็บและต้องพัก',
  'Hurt: resting {n} more min': 'บาดเจ็บ: พักอีก {n} นาที',
  'Losses in a row: {n}/{max}': 'แพ้ติดกัน {n}/{max}',
  'a monster': 'มอนสเตอร์',
  // Battle screen
  'nothing (time out)': 'ไม่ได้ออก (หมดเวลา)',
  you: 'คุณ',
  Round: 'รอบ',
  '{move} (key {key})': '{move} (ปุ่ม {key})',
  'Run away': 'หนี',
  'Battle Log': 'บันทึกการต่อสู้',
  'Choose your move': 'เลือกท่าของคุณ',
  '{name} has locked in a move… (it stays secret!)': '{name} เลือกท่าแล้ว… (ยังเป็นความลับนะ!)',
  '{name} steps up for an online battle!': '{name} ก้าวออกมาสู้ออนไลน์!',
  'A wild {name} appears!': 'ระวัง! {name} โผล่มาแล้ว!',
  '{name} has secretly picked a move. Your turn — Rock, Paper or Scissors?': '{name} แอบเลือกท่าไว้แล้ว ตาคุณ — ค้อน กระดาษ หรือกรรไกร?',
  'Pick your move before the timer runs out!': 'เลือกท่าก่อนหมดเวลานะ!',
  'Locked in! Waiting for {name}…': 'เลือกแล้ว! รอ {name} อยู่…',
  '⏱ {n}s': '⏱ {n} วิ',
  Battle: 'ประลอง',
  'Draw your choice and beat the monsters!': 'เลือกท่าให้ดี แล้วเอาชนะมอนสเตอร์ให้ได้!',
  'Hint:': 'คำใบ้:',
  'Rock beats Scissors, Scissors beats Paper, Paper beats Rock!': 'ค้อนชนะกรรไกร กรรไกรชนะกระดาษ กระดาษชนะค้อน!',
  Rewards: 'รางวัล',
  '(preview)': '(ตัวอย่าง)',
  coins: 'เหรียญ',
  'Defeat to get these!': 'ชนะเพื่อรับรางวัลเหล่านี้!',
  'Defeat to get these! (first win: {item})': 'ชนะเพื่อรับรางวัลเหล่านี้! (ชนะครั้งแรกได้: {item})',
  'Practice battle: no rewards.': 'ฝึกซ้อม: ไม่มีรางวัล',
  'Best rating': 'คะแนนดาวที่ดีที่สุด',
  'Online battle': 'ประลองออนไลน์',
  'Ranked: win for trophies!': 'จัดอันดับ: ชนะเพื่อรับถ้วยรางวัล!',
  'Results are decided by the server.': 'ผลตัดสินโดยเซิร์ฟเวอร์',

  // Guard / Focus stances
  Guard: 'ตั้งรับ',
  Focus: 'รวมพลัง',
  'Guard: take {n}% less damage if you lose (your hit is {n}% weaker if you win).': 'ตั้งรับ: ถ้าแพ้รอบนี้จะโดนดาเมจน้อยลง {n}% (แต่ถ้าชนะ ดาเมจของคุณก็ลดลง {n}% ด้วย)',
  'Focus: +{bonus}% damage if you win, but you take +{risk}% if you lose.': 'รวมพลัง: ถ้าชนะ ดาเมจ +{bonus}% แต่ถ้าแพ้จะโดนดาเมจ +{risk}%',
  'Optional stance (pick before your move)': 'ท่าทีเสริม (เลือกก่อนออกท่า ไม่บังคับ)',
  '{stance} ready — now pick Rock, Paper or Scissors!': '{stance} พร้อมแล้ว — เลือก ค้อน กระดาษ หรือกรรไกรเลย!',
  '{stance} (key {key})': '{stance} (ปุ่ม {key})',
  '{stance} (key {key}) — ready in {n} rounds': '{stance} (ปุ่ม {key}) — ใช้ได้อีกใน {n} รอบ',
  'Guarding!': 'ตั้งรับ!',
  'Focused!': 'รวมพลัง!',
  '{name} is guarding!': '{name} ตั้งรับอยู่!',
  '{name} is focused!': '{name} กำลังรวมพลัง!',
  'focused hit': 'โจมตีแบบรวมพลัง',
  'careful hit': 'โจมตีอย่างระวัง',
  'guard blocked half': 'ตั้งรับกันไว้ครึ่งหนึ่ง',
  'caught off guard': 'เปิดช่องให้โดนหนักขึ้น',
  'Combo ×{n}!': 'คอมโบ ×{n}!',

  // Ink gauge, class ultimates and combo chains
  Ultimate: 'ท่าไม้ตาย',
  'Ultimate!': 'ท่าไม้ตาย!',
  'Guard / Focus / Ultimate': 'ตั้งรับ / รวมพลัง / ท่าไม้ตาย',
  'Big Doodle Blast': 'ระเบิดดูเดิลยักษ์',
  'Mega Crayon Crash': 'สีเทียนถล่มโลก',
  'Paper Cut Storm': 'พายุกระดาษบาด',
  'Fortress Fold': 'ป้อมกระดาษพับ',
  'Clean Page': 'ลบใหม่หมดหน้า',
  'Vanishing Sketch': 'ภาพร่างล่องหน',
  'Ink Tsunami': 'สึนามิหมึก',
  'Shooting Star Wish': 'ดาวตกขอพร',
  'Neon Drain': 'ไฮไลต์ดูดพลัง',
  'Pencil Fortress': 'ป้อมดินสอแหลม',
  'Glue Wall': 'กำแพงกาว',
  'Permanent Marker Fury': 'เมจิกเดือดดาล',
  "hits for {n}% of the foe's max HP": 'โจมตี {n}% ของ HP สูงสุดศัตรู',
  '+{n}% more below half HP': 'แรงขึ้นอีก {n}% ตอนเลือดต่ำกว่าครึ่ง',
  'heals what it hits': 'ดูดเลือดกลับเท่าที่ตี',
  'heals {n}% of your max HP': 'ฟื้น HP {n}% ของเลือดสูงสุด',
  "blocks the hand's hit this round": 'กันดาเมจจากการเป่ายิงฉุบรอบนั้นได้หมด',
  '{name}: {effects}. Fill the ink gauge by winning rounds.': '{name}: {effects} — เติมเกจหมึกด้วยการชนะรอบ',
  'Combo chain: win {n} rounds in a row with different hands for a bonus hit!': 'โซ่คอมโบ: ชนะติดกัน {n} รอบด้วยท่าที่ไม่ซ้ำกัน จะได้โจมตีโบนัส!',
  '✨ {name} ready — now pick Rock, Paper or Scissors!': '✨ {name} พร้อมแล้ว — เลือก ค้อน กระดาษ หรือกรรไกรเลย!',
  '✨ Your ink is full! Press Ultimate (U), then pick your hand.': '✨ เกจหมึกเต็มแล้ว! กดท่าไม้ตาย (U) แล้วเลือกท่าได้เลย',
  'Ultimate (key U): ready!': 'ท่าไม้ตาย (ปุ่ม U): พร้อมใช้!',
  'Ultimate (key U): ink {n} / {max}': 'ท่าไม้ตาย (ปุ่ม U): หมึก {n} / {max}',
  'Ink {n} / {max}': 'หมึก {n} / {max}',
  'R{round}: {moves} — the ultimate ended it before the hands landed!': 'R{round}: {moves} — ท่าไม้ตายจบเกมก่อนจะได้เป่ายิงฉุบ!',
  'the ultimate shield blocked it all': 'โล่ท่าไม้ตายกันไว้ได้หมด',
  '{n} dmg': 'ดาเมจ {n}',
  '+{n} HP': '+{n} HP',
  'shield up': 'กางโล่',
  '✨ {name} unleashes {ult}! ({effects})': '✨ {name} ปล่อย {ult}! ({effects})',
  'CHAIN!': 'โซ่คอมโบ!',
  '✊✋✌️ Chain burst! {name} won with three different hands: +{n} dmg and extra ink.': '✊✋✌️ โซ่คอมโบแตก! {name} ชนะด้วยสามท่าไม่ซ้ำ: ดาเมจเพิ่ม {n} และได้หมึกเพิ่ม',

  // Battle log
  '{a} vs {b}': '{a} ปะทะ {b}',
  'R{round}: {moves} — tie, no damage.': 'รอบ {round}: {moves} — เสมอ ไม่มีดาเมจ',
  '{name} erased some scratches (+{hp} HP).': '{name} ลบรอยขีดข่วนออกไปนิดหน่อย (+{hp} HP)',
  'critical!': 'คริติคอล!',
  'but it was dodged': 'แต่หลบได้',
  'paper shield blocked half': 'โล่กระดาษกันไว้ครึ่งหนึ่ง',
  'highlighter drained +{hp} HP': 'ปากกาดูดพลัง +{hp} HP',
  'sharpener spikes hit back for {n}': 'หนามกบเหลาดินสอสะท้อนกลับ {n}',
  'R{round}: {moves} — {name} wins': 'รอบ {round}: {moves} — {name} ชนะ',
  'R{round}: {moves} — {name} wins, {damage} dmg': 'รอบ {round}: {moves} — {name} ชนะ ดาเมจ {damage}',
  '{line} ({extras}).': '{line} ({extras})',
  '{line}.': '{line}',
  'COMBO ×{n}': 'คอมโบ ×{n}',
  'The battle is over — a draw!': 'จบการต่อสู้แล้ว — เสมอ!',
  'The battle is over!': 'จบการต่อสู้แล้ว!',
  'The battle ends in a draw.': 'การต่อสู้จบลงด้วยการเสมอ',
  '{name} wins! ({reason})': '{name} ชนะ! ({reason})',

  // End reasons
  knockout: 'น็อก',
  'out of rounds': 'ครบจำนวนรอบ',
  'running away': 'หนี',
  'time out': 'หมดเวลา',
  disconnect: 'หลุดการเชื่อมต่อ',

  // Online battle memories
  'a friend': 'เพื่อนคนหนึ่ง',
  'Beat {name} online': 'ชนะ {name} ออนไลน์',
  'Lost to {name} online': 'แพ้ {name} ออนไลน์',
  'Tied with {name} online': 'เสมอกับ {name} ออนไลน์',
  'Ranked: {trophies} trophies.': 'จัดอันดับ: {trophies} ถ้วยรางวัล',
  'Classroom battle (unranked).': 'การต่อสู้ในห้องเรียน (ไม่จัดอันดับ)',
  'Ended by {reason}.': 'จบเพราะ {reason}',

  // Result card
  'VICTORY!': 'ชนะแล้ว!',
  'DEFEAT…': 'แพ้แล้ว…',
  DRAW: 'เสมอ',
  'Practice battle (classroom monster): no rewards, no progress.': 'ฝึกซ้อม (มอนสเตอร์ห้องเรียน): ไม่มีรางวัล ไม่นับความคืบหน้า',
  '+{n} coins': '+{n} เหรียญ',
  'LEVEL UP! Now level {level} — spend your new stat points!': 'เลเวลอัป! ตอนนี้เลเวล {level} แล้ว — ไปใช้แต้มสเตตัสใหม่กันเลย!',
  'Found: {item}!': 'ได้ของ: {item}!',
  '{n} of 3 stars': '{n} จาก 3 ดาว',
  'New best!': 'สถิติใหม่!',
  'Quest ready to claim: {quest}': 'เควสต์พร้อมรับรางวัล: {quest}',
  'Ranked battle: {trophies} trophies': 'การต่อสู้จัดอันดับ: {trophies} ถ้วยรางวัล',
  'Classroom battle — not ranked.': 'การต่อสู้ในห้องเรียน — ไม่จัดอันดับ',
  'Ended by: {reason}. Results were decided by the server.': 'จบเพราะ: {reason} ผลตัดสินโดยเซิร์ฟเวอร์',
  'Fight again': 'สู้อีกครั้ง',
  'Upgrade hero': 'อัปเกรดฮีโร่',
  'Back to notebook': 'กลับไปที่สมุด',
  'Next: {monster} ▶': 'ตัวต่อไป: {monster} ▶',
  'Next monster ▶': 'มอนตัวต่อไป ▶',
  'Back to the room': 'กลับไปที่ห้อง',

  // Run away
  'Run away?': 'จะหนีเหรอ?',
  'Running away counts as a loss for this battle.': 'ถ้าหนี จะนับว่าแพ้การต่อสู้นี้นะ',
  'You will lose this battle (but keep a little EXP).': 'คุณจะแพ้การต่อสู้นี้ (แต่ยังได้ EXP นิดหน่อย)',
  'Run!': 'หนีเลย!',
  'Keep fighting': 'สู้ต่อ',
  'Move rejected': 'ส่งท่าไม่สำเร็จ',

  // Diary memories (progression)
  '{hero} beat {monster}': '{hero} ชนะ {monster}',
  '{hero} lost to {monster}': '{hero} แพ้ {monster}',
  '{hero} tied with {monster}': '{hero} เสมอกับ {monster}',
  '{rounds} rounds, best combo ×{combo}.': '{rounds} รอบ คอมโบสูงสุด ×{combo}',
  '(practice — classroom rules)': '(ฝึกซ้อม — กติกาห้องเรียน)',
  'Level {n}!': 'เลเวล {n}!',
  '{name} grew up a little. +{points} stat points.': '{name} โตขึ้นอีกนิดแล้ว +{points} แต้มสเตตัส',
  'Quest done: {quest}': 'ทำเควสต์สำเร็จ: {quest}',
  '+{exp} EXP, +{coins} coins.': '+{exp} EXP, +{coins} เหรียญ',
  '+{exp} EXP, +{coins} coins, {item}.': '+{exp} EXP, +{coins} เหรียญ, {item}',
  'Bought {item}': 'ซื้อ {item}',

  // Notebook cover
  'Name: ______': 'ชื่อ: ______',
  'Class: ___': 'ชั้น: ___',

  // Validation (budget.ts)
  '{label} must be a whole number': '{label} ต้องเป็นจำนวนเต็ม',
  '{label} must be between {min} and {max}': '{label} ต้องอยู่ระหว่าง {min} ถึง {max}',
  'Unknown skill': 'ไม่รู้จักสกิลนี้',
  'Name must be 1-24 characters': 'ชื่อต้องยาว 1-24 ตัวอักษร',
  'Unknown personality': 'ไม่รู้จักนิสัยนี้',
  'EXP reward must be 0 or more': 'รางวัล EXP ต้องเป็น 0 ขึ้นไป',
  'Coin reward must be 0 or more': 'รางวัลเหรียญต้องเป็น 0 ขึ้นไป',
  'Stat budget exceeded: {power}/{budget}': 'แต้มสเตตัสเกินงบ: {power}/{budget}',
  'EXP reward too high (max {max})': 'รางวัล EXP สูงเกินไป (สูงสุด {max})',
  'Coin reward too high (max {max})': 'รางวัลเหรียญสูงเกินไป (สูงสุด {max})',
  'Over the arena budget ({power}/{budget})': 'เกินงบของสนามประลอง ({power}/{budget})',
};
